import { render, staticRenderFns } from "./Diccionario.vue?vue&type=template&id=528ef14b&scoped=true"
import script from "./Diccionario.vue?vue&type=script&lang=js"
export * from "./Diccionario.vue?vue&type=script&lang=js"
import style0 from "./Diccionario.vue?vue&type=style&index=0&id=528ef14b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528ef14b",
  null
  
)

export default component.exports